module.exports = __webpack_public_path__ + "img/topicHiTech.caabde4e.png";